var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "text-white",
          attrs: {
            color: _vm.color,
          },
          on: {
            mousedown: _vm.start,
            mouseleave: _vm.stop,
            mouseup: _vm.stop,
            touchstart: _vm.start,
            touchend: _vm.stop,
            touchcancel: _vm.stop,
          },
        },
        [
          _c("v-progress-circular", {
            staticClass: "mr-2",
            attrs: {
              size: 20,
              rotate: -90,
              value: _vm.progress,
              width: 3,
              color: "white",
            },
          }),
          _vm._v("\n    " + _vm._s(_vm.label) + "\n  "),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }